<template>
  <div :class="classList" class="c-alert flex">
    <div v-if="icon" class="ltr:pr-3 rtl:pl-3">
      <c-icon :color="color" :icon="icon" class="h-7"/>
    </div>
    <div class="space-y-2">
      <div v-if="title" class="c-alert__title font-heading6">{{ title }}</div>
      <div v-if="text || 'default' in $slots" class="font-body2">
        {{ text }}
        <slot/>
      </div>
      <div v-if="actions" class="pt-3 first:pt-0">
        <c-button
          v-for="action in actions"
          :key="action.value"
          :color="color"
          tag="a"
          v-bind="action"
          @click="onClick(action.value)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CButton from '@/components/CButton'
import CIcon from '@/components/CIcon'
import { props } from './props'
import { computed } from 'vue'

export default {
  name: 'CAlert',
  components: {
    CButton,
    CIcon
  },
  props,
  emits: ['on-click'],
  setup (props, context) {
    const classList = computed(() => {
      return {
        'bg-basic-overlay': props.color === 'basic',
        'bg-primary-overlay': props.color === 'primary',
        'bg-secondary-overlay': props.color === 'secondary',
        'bg-success-overlay': props.color === 'success',
        'bg-info-overlay': props.color === 'info',
        'bg-warning-overlay': props.color === 'warning',
        'bg-error-overlay': props.color === 'error',
        'bg-disabled-overlay': props.color === 'disabled',
        'p-4 text-basic-medium rounded-md': props.dense,
        'p-6 rounded-lg': !props.dense
      }
    })

    const onClick = value => context.emit('on-click', value)

    return {
      classList,
      onClick
    }
  }
}
</script>

<style lang="scss"/>
